import React from 'react';
import styles from './total.module.scss';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import {Lx} from '../../../i18n/consts';
import ProgressIndicator from '../progress-indicator';
import {useMediaQuery} from 'react-responsive';
import {Tooltip} from '@mui/material';

interface Props {
    workHours?: number;
    absenceHours?: number;
    approved: number;
    approvableHours?: number;
    billed: number;
    approvable?: number;
    billable?: number;
    totalHours?: number;
    hideTrackingHours?: boolean;
    hidePlanned?: boolean;
    hideBillable?: boolean;
    ready?: boolean;
    plannedHours?: number;
}

const TotalV2: React.FC<Props> = (props) => {
    const { workHours, absenceHours, approved, approvableHours, billed, approvable, billable, totalHours, hideTrackingHours, hideBillable, ready, plannedHours, hidePlanned } = props;
    const isMobile = useMediaQuery({ maxWidth: 1000 });
    const indicatorSize = isMobile ? 18 : 20;
    const calculatedApproved = approvableHours && (approved / approvableHours) * 100;
    const calculatedBilled = workHours !== undefined
        ? (workHours > 0 ? (billed / workHours) * 100 : 0)
        : undefined;
    const hasTrackingTotals = !hideTrackingHours;
    const showPlanned = hasTrackingTotals && !hidePlanned;
    const showBillable = !hideBillable;
    const isFourPartLayout = hasTrackingTotals && !showPlanned && showBillable;


    return (<div className={classNames({
        [styles.total]: true,
        [styles.twoCol]: hideTrackingHours,
        [styles.fourParts]: isFourPartLayout,
    })}>
        {
            !hideTrackingHours && <>
                {
                    !hidePlanned && <div className={styles.totalPart}>
                        {
                            plannedHours === undefined || ready !== undefined && !ready && 0
                        }
                        {
                            plannedHours !== undefined && <>
                                <p>
                                    <Tooltip title={<FormattedMessage id={Lx.Schedule.PLANNED_HOURS} />}>
                                        <span className={styles.title}><FormattedMessage id={Lx.Schedule.PLANNED_HOURS_ABBREVIATION} /> </span>
                                    </Tooltip>:
                                </p><span className={styles.totalValue}>{Math.round(plannedHours * 10) / 10}</span>
                            </>
                        }
                    </div>
                }
                {
                    <div className={styles.totalPart}>
                        {
                            workHours === undefined || ready !== undefined && !ready && 0
                        }
                        {
                            workHours !== undefined && <>
                                <p><Tooltip title={<FormattedMessage id={Lx.Schedule.WORKED_HOURS} />}>
                                    <span><FormattedMessage id={Lx.Schedule.WORKED_HOURS_ABBREVIATION} /></span>
                                </Tooltip>:
                                </p><span className={styles.totalValue}>{Math.round(workHours * 10) / 10}</span>
                            </>
                        }
                    </div>
                }
                {
                    <div className={styles.totalPart}>
                        {
                            absenceHours === undefined || ready !== undefined && !ready && 0
                        }
                        {
                            absenceHours !== undefined && <>
                                <p><Tooltip title={<FormattedMessage id={Lx.Schedule.ABSENCE_HOURS} />}>
                                    <span><FormattedMessage id={Lx.Schedule.ABSENCE_HOURS_ABBREVIATION} /></span>
                                </Tooltip>:
                                </p><span className={classNames(styles.totalValue, styles.totalAbsence)}>{Math.round(absenceHours * 10) / 10}</span>
                            </>
                        }
                    </div>
                }
            </>
        }
        <div className={classNames({
            [styles.totalPart]: true,
            [styles.withIndicator]: true,
            [styles.inactive]: approved < 1,
        })}>
            {
                totalHours === undefined || ready !== undefined && !ready && 0
            }
            {
                totalHours !== undefined && <>
                    <p><FormattedMessage id={Lx.Schedule.APPROVED_HOURS}/>:</p><span
                        className={classNames(styles.totalValue, styles.totalApproved)}>{Math.round(approved * 10)/ 10}</span>
                    {<span className={classNames({
                        [styles.indicator]: true,
                        [styles.active]: calculatedApproved !== undefined
                    })}>
                        <ProgressIndicator type={'approve'} value={calculatedApproved ? calculatedApproved : 0} showWhenZero size={indicatorSize} />
                    </span>}
                </>
            }
        </div>
        <div className={classNames({
            [styles.totalPart]: true,
            [styles.withIndicator]: true,
            [styles.inactive]: billed < 1,
            [styles.hide]: hideBillable
        })}>
            {
                totalHours === undefined || ready !== undefined && !ready && 0
            }
            {
                totalHours !== undefined && <>
                    <p><FormattedMessage id={Lx.Schedule.BILLABLE_HOURS}/>:</p><span
                        className={classNames(styles.totalValue, styles.totalBillable)}>{Math.round(billed * 10)/ 10}</span>
                    <span className={classNames({
                        [styles.indicator]: true,
                        [styles.active]: calculatedBilled !== undefined
                    })}>
                        <ProgressIndicator type={'billable'} value={calculatedBilled ?? 0} showWhenZero size={indicatorSize} />
                    </span>
                </>
            }
        </div>
    </div>)
}

export default TotalV2;
